<div data-testid="seat-utilisation" class="seat-utilisation">
  <header class="seat-utilisation__header">
    <div class="seat-utilisation__titles">
      <h4 class="seat-utilisation__title">Seat utilisation</h4>
      <p *ngIf="hasPoints" data-testid="seat-subtitle" class="seat-utilisation__subtitle">
        Active users in the last 30 days against licensed seats.
        <span data-testid="seat-over" class="seat-utilisation__over">{{ overText }}</span> ·
        <span data-testid="seat-under" class="seat-utilisation__under">{{ underText }}</span>
      </p>
    </div>
  </header>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="seat-failed" icon="fa-regular fa-circle-exclamation"
                             [title]="failedTitle" body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="data?.notApplicable" data-testid="seat-na" icon="fa-regular fa-address-card"
                             [title]="notApplicableText"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="data?.pending" data-testid="seat-pending" icon="fa-regular fa-clock"
                             [title]="pendingText"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="isEmpty" data-testid="seat-empty" icon="fa-regular fa-users"
                             [title]="emptyText"></app-admin-dashboard-empty>
  <div *ngIf="hasPoints" #chart data-testid="seat-chart" class="seat-utilisation__chart"></div>
  <div *ngIf="!loaded" class="seat-utilisation__chart"></div>
</div>
